// Copy for primitives, overlays and shared states. Keys are dotted; tr and en must have the same keys.
// Turkish part; base.en.ts must have the same keys.
const dict: Record<string, string> = {
  'common.close': 'Kapat',
  'common.cancel': 'Vazgeç',
  'common.loading': 'Yükleniyor',
  'common.verified': 'Doğrulanmış',
  'common.soon': 'Yakında',
  'common.more': 'Daha fazla',
  'common.retry': 'Tekrar dene',
  'common.remove': 'Kaldır',
  'common.copy': 'Kopyala',
  'common.copied': 'Kopyalandı',
  'common.search': 'Ara',
  'common.save': 'Kaydet',
  'common.saved': 'Kaydedildi',
  'common.reset': 'Sıfırla',
  'common.options': 'Seçenekler',
  'tristate.deny': 'Reddet',
  'tristate.inherit': 'Varsayılan',
  'tristate.allow': 'İzin ver',
  'sheet.back': 'Geri',
  'sheet.actions': 'İşlemler',
};

export default dict;
